/** Static consent / privacy document linked from the signup form. */
export default function ConsentPage() {
  return (
    <main className="container legal-page">
      <h1>Privacy &amp; Consent</h1>
      <p className="text-muted">Consent version: v1 &mdash; May 2026</p>

      <h2>What we collect</h2>
      <p>When you sign up for a Barbridge card at a participating venue we collect:</p>
      <ul>
        <li>Your mobile phone number</li>
        <li>Your first and last name</li>
        <li>Your email address</li>
        <li>Your date of birth (used only to verify that you are 21 or older)</li>
        <li>Your consent choices and the date/time they were recorded</li>
      </ul>

      <h2>How we use your information</h2>
      <p>
        Your phone number is used to send you a single one-time verification link at signup. Your
        name, email, and phone are shared with the venue and used to create your loyalty card in
        Square. Your date of birth is stored for age-verification purposes only and is not shared
        with the venue.
      </p>

      <h2>SMS messages</h2>
      <p>
        By checking the required consent box at signup you agree to receive one transactional text
        message containing your verification link. Reply <strong>STOP</strong> at any time to opt
        out of all future messages. Message and data rates may apply.
      </p>

      <h2>Marketing messages</h2>
      <p>
        If you choose to opt in to marketing messages, the venue may send you promotional texts via
        Barbridge in the future. You can opt out at any time by replying <strong>STOP</strong>.
        Opting out of marketing messages does not affect your card or any prior redemptions.
      </p>

      <h2>Data retention</h2>
      <p>
        Your information is retained for as long as you hold an active card at a participating
        venue. You may request deletion by contacting us at the address below.
      </p>

      <h2>Contact</h2>
      <p>
        Questions or deletion requests:{' '}
        <a href="mailto:privacy@barbridge.io">privacy@barbridge.io</a>
      </p>
    </main>
  );
}
